import { useRef, useEffect } from 'react'

import * as Styled from './styled'
import { ITabbarItem } from '../types'

interface IProps extends ITabbarItem {
  isActive: boolean
  onClick: (payload: string) => void
  updateTabWrapperRect: (width: number, left: number) => void
}

export const TabbarItem: React.FC<IProps> = ({
  name,
  text,
  isActive,
  onClick,
  updateTabWrapperRect
}) => {
  const textRef = useRef<HTMLElement | null>(null)
  const tabItemRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (isActive) {
      if (tabItemRef.current) {
        const { offsetLeft, offsetWidth } = tabItemRef.current
        updateTabWrapperRect(offsetWidth, offsetLeft)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, tabItemRef.current, updateTabWrapperRect])

  return (
    <Styled.TabbarItem onClick={() => onClick(name)} ref={tabItemRef}>
      <Styled.Text
        color={isActive ? 'primaryDark' : 'secondary'}
        type={isActive ? 'h3' : 'h4'}
        $isActive={isActive}
        elementRef={textRef}
      >
        {text}
      </Styled.Text>
    </Styled.TabbarItem>
  )
}
